/**
 * Created by zhj on 2/2/2015.
 */
'use strict';
angular.module('betosyswebapp')
  .controller('FootbarCtrl', function ($scope, versionService, AuthenticationService, version, commonTrackService, accountConfig) {
    $scope.cVersion = '';
    $scope.clientVersion = version;
    $scope.gtseVersion = '';
    $scope.imprintUrl = '';
    $scope.dataPrivacyUrl = '';

    var accountID = window.location.hostname.split('.')[0];
    $scope.accountID = accountID;
    $scope.imprintUrl = accountConfig.imprintUrls[accountID] || accountConfig.imprintUrls['default'];
    $scope.dataPrivacyUrl = accountConfig.dataPrivacyUrls[accountID] || accountConfig.dataPrivacyUrls['default'];

    $scope.isShowDatabaseVersion = false;
    $scope.isShowGtseVersion = false;
    var viewPortName = commonTrackService.getViewPortName();
    $scope.isBiggerScreen = viewPortName === 'MD' || viewPortName === 'LG' ? true : false;
    $scope.smallerScreenFooterText = 'DSA - ';

    $scope.$watch(function () {
      return AuthenticationService.IsLogin();
    }, function (data) {
      if (data) {
        versionService.getVersion().then(function (versionInfo) {
          $scope.cVersion = versionInfo.dbVersion;
          $scope.smallerScreenFooterText += $scope.clientVersion;
          $scope.isShowGtseVersion = true;
          $scope.gtseVersion = versionInfo.gtseVersion.trim();
          $scope.smallerScreenFooterText += ' / ' + $scope.gtseVersion;
        });
      } else {
        $scope.isShowGtseVersion = false;
      }
    }, true);
  });



// WEBPACK FOOTER //
// ./.tmp/components/footerbar/footerbarController.js